import i18n from '@/i18n'

export default [
  {
    path: '/noteSet',
    meta: {
      title: i18n.t('menu.noteSet'),
      leftMenuCode: 'User'
    },
    component: () => import('@/views/noteSet/index.vue')
  }
]